import React from 'react'
import { Link } from 'react-router-dom'

const DeliveryOne = () => {
    return (
        <div className="delivery-section">
            <div className="container container-lg">
                <div className="delivery delivery-gradient delivery-version-two position-relative rounded-16 p-16 flex-align gap-16 flex-wrap z-1">
                    <div
                        className="position-absolute inset-block-start-0 inset-inline-start-0 z-n1 w-100 h-100"
                        style={{
                            backgroundImage: 'url("assets/images/bg/backhero.png")',
                            backgroundSize: 'cover',
                            backgroundPosition: 'center',
                            backgroundRepeat: 'no-repeat',
                            opacity: 0.3
                        }}
                    />
                    <div className="row align-items-center justify-content-center">
                        <div className="col-md-3 d-md-block d-none">
                            <div className="delivery__man text-center d-flex justify-content-center">
                                <img src="assets/images/thumbs/delivery-man.png" alt="" />
                            </div>
                        </div>
                        <div className="col-md-1 d-md-block d-none delivery-liner-col">
                            <img src="assets/images/thumbs/liner.png" alt="" className="delivery-liner" />
                        </div>
                        <div className="col-md-8 col-sm-12">
                            <div className="text-center">
                                <h4 className="text-black mb-8">
                                    Livraison partout au Maroc
                                </h4>
                                <p className="text-black">Service rapide et fiable</p>
                                <Link
                                    to="/shop"
                                    className="mt-16 btn delivery-btn fw-medium d-inline-flex align-items-center rounded-pill gap-8 text-white"
                                    tabIndex={0}
                                >
                                    Achetez maintenant
                                    <span className="icon text-xl d-flex">
                                        <i className="ph ph-arrow-right" />
                                    </span>
                                </Link>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>

    )
}

export default DeliveryOne